import React from 'react';
import addressOptions from '../utils';

interface AddressTypeProps {
  addressType: string;
  setAddressType: (value: string) => void;
}

const AddressType: React.FC<AddressTypeProps> = ({
  addressType,
  setAddressType,
}) => {
  return (
    <div className="govuk-form-group">
      <div id="passport-issued-hint" className="govuk-hint">
        The type of address e.g. Main address, Temp address
      </div>

      <select
        className="govuk-select carehome-partner-select"
        id="carehome-partner-list"
        name="carehome-partner-list"
        value={addressType ?? ''}
        onChange={e => {
          setAddressType(e.target.value);
        }}
      >
        <option value="" className="govuk-header__link" disabled>
          Select address type
        </option>
        {addressOptions?.map(option => {
          return (
            <option
              value={option.value}
              className="govuk-header__link"
              key={option.value}
            >
              {option.label}
            </option>
          );
        })}
      </select>
    </div>
  );
};

export default AddressType;
